import React from 'react'

import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

export default function Copyright() {
  const fullYear = new Date().getFullYear()
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://tangelo.ai">
        TangeloAi
      </Link>
      {` ${fullYear}`}
    </Typography>
  )
}
